module.exports = __webpack_public_path__ + "img/e_3_20_r.c9fd8054.png";